module.exports = __webpack_public_path__ + "img/speed.5060c636.png";